export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'

export const SET_USER_INFO = 'SET_USER_INFO'
export const RESET_USER_INFO = 'RESET_USER_INFO'
